import React from 'react'
import SharedRoutes from '_routes/SharedRoutes'
import PreviewRoutes from '_routes/PreviewRoutes'
import AppWrapper from '_layout/AppWrapper'
import AppNormal from '_layout/App/AppNormal'

export const App = ({ location, setAppMode = () => {} }) => {
  const pathname = location?.pathname || ''

  if (/^\/share\//.test(pathname)) {
    return (
      <AppWrapper mode="shared" className="shared-mode">
        <SharedRoutes />
      </AppWrapper>
    )
  }

  if (/^\/preview\//.test(pathname)) {
    return (
      <AppWrapper mode="preview" className="preview-mode">
        <PreviewRoutes />
      </AppWrapper>
    )
  }

  return <AppNormal pathname={pathname} />
}

export default App
